<template>
	<div>
		<global-message
			v-if="isLoading"
			type="info"
			value="<strong>Setting up your account...</strong>"
		/>

		<form
			:class="[
				'styled-form',
				'styled-form--white-box',
				{'is-loading': isLoading}
			]"
			@submit.prevent="onSubmit"
			name="login_form"
		>

			<div v-if="isLoading" class="styled-form__overlay">
				<div class="preloader"></div>
			</div>

			<global-message v-if="errors.global" :value="errors.global"></global-message>

			<div class="styled-form__header">
				<h2 class="styled-form__title">Confirm your password</h2>
				<h3 class="styled-form__subtitle">Please enter your password to finalise your registration</h3>
			</div>

			<div class="styled-form__corset">

				<form-input
					v-model="data.password"
					type="password"
					name="password"
					label="Password"
					:error="errors.password"
				></form-input>

				<div class="text--center">
					<button class="btn">Continue</button>
				</div>

			</div>

		</form>
	</div>
</template>

<script>
	import isEmail from '../../helpers/isEmail';
	import FormInput from '../formFields/FormInput.vue';
	import GlobalMessage from '../messages/GlobalMessage.vue';

	export default {
		components: {
			FormInput,
			GlobalMessage
		},
		props: {
			submit: {
				type: Function,
				required: true
			},
			email: String
		},
		data() {
			return {
				isLoading: false,
				data: {
					email: '',
					password: '',
				},
				errors: {}
			}
		},
		created() {
			this.validateProps();
		},
		methods: {
			validateProps() {
				if (isEmail(this.email)) {
					let emailProp = this.email;
					this.data.email = emailProp.toLowerCase();
				}
			},
			onSubmit() {
				this.errors = this.validate(this.data);

				if (Object.keys(this.errors).length === 0) {
                    this.data.email = this.data.email.toLowerCase();
					this.isLoading = true;
					this.submit(this.data).catch(errors => {
						this.isLoading = false;
						this.errors = errors;

						if (errors instanceof Error) {
							// console.error(errors);
						}
					});
				}
			},
			validate(data) {
				const errors = {};

				if (!data.password.length) errors.password = 'This field is required';

				return errors;
			}
		}

	};
</script>

<style lang="scss" scoped>

</style>
